// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__bLBeR","scroll":"Auth_scroll__IJVwA","auth":"Auth_auth__-scmW","authForm":"Auth_authForm__Zayib","title":"Auth_title__MfTGo","link":"Auth_link__EgNqP"};